import { useTranslation } from "react-i18next";

export default function None() {
  const { t } = useTranslation();

  return (
    <div className="p-5">
      <h1>404 {t("Page not found")}</h1>
    </div>
  );
}
